import translations from "@/public/assets/locales/en.json";

type TranslationPath = string;

/*
 * Returns a string from the "translations" json based on the provided "path".
 * If the requested path was not found in the json, returns the path itself.
 *
 * Example:
 * 	t("pages.home.text-learn") => "Learn"
 *  t("pages.home.text-learn", { lang: "english" }) => "Learn english"
 */

const t = (
	path: TranslationPath,
	options?: Record<string, string | number>
): string => {
	const keys = path.split(".");
	let current: Record<string, any> | string = translations;

	for (const key of keys) {
		if (current[key as keyof typeof current] !== undefined) {
			current = current[key as keyof typeof current] as
				| Record<string, any>
				| string;
		}
	}

	if (typeof current === "string") {
		if (options) {
			// replace any variables from the translation
			for (const [key, value] of Object.entries(options)) {
				current = current.replace(
					new RegExp("{" + key + "}", "mig"),
					String(value)
				);
			}
		}

		return current;
	}

	return path;
};

export default t;
